<!--
/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="apcwo-pr-rating" role="radiogroup">
    <button
      v-for="n in 5"
      :key="n"
      type="button"
      role="radio"
      :aria-checked="modelValue === n"
      :disabled="readonly"
      :class="[
        'apcwo-pr-rating__dot',
        {'apcwo-pr-rating__dot--on': modelValue === n},
      ]"
      @click="select(n)"
    >
      {{ n }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'RatingInput',
  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    select(n) {
      if (this.readonly) return;
      this.$emit('update:modelValue', this.modelValue === n ? null : n);
    },
  },
};
</script>

<style>
.apcwo-pr-rating {
  display: inline-flex;
  gap: 6px;
}
.apcwo-pr-rating__dot {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #c4c4d0;
  background: #fff;
  font-weight: 600;
  color: #4b4b5a;
  cursor: pointer;
}
.apcwo-pr-rating__dot:disabled {
  cursor: default;
}
.apcwo-pr-rating__dot--on {
  background: #741e1e;
  border-color: #741e1e;
  color: #fff;
}
</style>
